import { TypographyXS } from "@/components/typography/XS";
import { Button } from "@/components/ui/button";
import Card from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

export function OrganizationCreateLink() {
  return (
    <Card className="min-w-[30%] w-full max-w-lg p-4 flex justify-between gap-x-8 items-center">
      <TypographyXS>
        Create your own organization to get started with Numerous.
      </TypographyXS>
      <Link to="/organization-create" search={{ redirect: undefined }}>
        <Button variant="secondary">
          Create organization <ArrowRight size={14} className="ml-2" />
        </Button>
      </Link>
    </Card>
  );
}
